import { Routes } from '@angular/router';
import { MainLayoutComponent } from './infrastructure/ui/layout/main-layout/main-layout.component';
import { AuthGuard } from '@infra-adapters/guards/auth.guard';
import { NotAuthGuard } from '@infra-adapters/guards/not-auth.guard';
import { OnboardingGuard } from '@infra-adapters/guards/onboarding.guard';
import { TutorialGuard } from '@infra-adapters/guards/tutorial.guard';
import { PaymentPageComponent } from '@infra-ui/pages/payment-page/payment-page.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'tutorial',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/dashboard/dashboard.component'
          ).then((m) => m.DashboardComponent),
      },
      {
        path: 'tutorial',
        canActivate: [TutorialGuard],
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/dashboard/components/tutorial/tutorial.component'
          ).then((m) => m.TutorialComponent),
      },
      {
        path: 'tratamientos/reservar',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/appointment-booking/appointment-booking.component'
          ).then((m) => m.AppointmentBookingComponent),
      },
      {
        path: 'recomendaciones',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/recommendations/recommendations.component'
          ).then((m) => m.RecommendationsComponent),
      },
      {
        path: 'reservas',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/dashboard/components/appointment-nav/appointment-nav.component'
          ).then((m) => m.AppointmentNavComponent),
      },
      {
        path: 'mis-citas',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/my-appointments/my-appointments.component'
          ).then((m) => m.MyAppointmentsComponent),
      },
      {
        path: 'clinicas-favoritas',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/preferred-clinics/preferred-clinics.component'
          ).then((m) => m.PreferredClinicsComponent),
      },
      {
        path: 'clinicas-favoritas/agregar',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/add-preferred-clinics/add-preferred-clinics.component'
          ).then((m) => m.AddPreferredClinicsComponent),
      },
      {
        path: 'perfil',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/profile/profile.component'
          ).then((m) => m.ProfileComponent),
      },
      {
        path: 'historial',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/history/history.component'
          ).then((m) => m.HistoryComponent),
      },
      {
        path: 'notificaciones',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/notifications/notifications.component'
          ).then((m) => m.NotificationsComponent),
      },
      {
        path: 'tienda',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/store/store.component'
          ).then((m) => m.StoreComponent),
      },
      {
        path: 'tienda/producto',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/store/components/product-page/product-page.component'
          ).then((m) => m.ProductPageComponent),
      },
      {
        path: 'carrito',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/shopping-cart/shopping-cart.component'
          ).then((m) => m.ShoppingCartComponent),
      },
      {
        path: 'pago',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/payment-page/payment-page.component'
          ).then((m) => m.PaymentPageComponent),
      },
      {
        path: 'historial-compras',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/purchase-history/purchase-history.component'
          ).then((m) => m.PurchaseHistoryComponent),
      },
      {
        path: 'payment-result',
        loadComponent: () =>
          import(
            './infrastructure/ui/pages/payment-result/payment-result.component'
          ).then((m) => m.PaymentResultComponent),
      }
    ],
  },
  {
    path: 'registro',
    canActivate: [NotAuthGuard],
    loadComponent: () =>
      import('./infrastructure/ui/pages/register/register.component').then(
        (m) => m.RegisterComponent
      ),
  },
  {
    path: 'login',
    canActivate: [NotAuthGuard],
    loadComponent: () =>
      import('./infrastructure/ui/pages/login/login.component').then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: 'codigo-verificacion',
    canActivate: [NotAuthGuard],
    loadComponent: () =>
      import(
        './infrastructure/ui/pages/verification-code/verification-code.component'
      ).then((m) => m.VerificationCodeComponent),
  },
  {
    path: 'onboarding',
    canActivate: [NotAuthGuard, OnboardingGuard],
    loadComponent: () =>
      import(
        './infrastructure/ui/pages/onboarding/onboarding.component'
      ).then((m) => m.OnboardingComponent),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
